var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-headful',{attrs:{"title":`Write for me!`,"description":`Latest tasks`}}),_c('v-row',[_c('v-col',[_c('TaskList',{attrs:{"list-type":"latestPublicTasks","list-title":"Latest public tasks","list-length":10,"show-creation-date":"true","show-creator":"true"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }